<template>
  <div style="color: #000000">
    <table
      v-show="status == 'print'"
      id="printTable"
      style="width:100%;border-collapse: collapse;font-size: 10px !important;"
    >
      <thead>
        <tr>
          <td
            colspan="6"
            align="center"
            style="font-size: 16px;font-weight: bold"
          >
            {{ $store.state.abrName }}
          </td>
        </tr>
        <tr>
          <td
            colspan="4"
            style="border-left: #ffffff;font-size: 10px;"
          >
            <div style="display: grid;">
<!--              <div>-->
<!--                {{ $t('id') }} : {{ id }}-->
<!--              </div>-->
              <div>
                {{ $t('number') }} : {{ number }}
              </div>
            </div>
          </td>
          <td
            colspan="2"
            style="border-right: #ffffff"
          >
            <div style="display: grid;float: left">
              <div style="text-align: left;">
                {{ time }}
              </div>
              <div style="text-align: left">
                {{ date }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="width: 100%"
            colspan="6"
          >
            <div style="font-size: 10px;padding-right: 5px;">
              <div>{{ $t('detailsName') }} : {{ (account ? account.name : '') }}</div>
              <div>{{ $t('mobile') }} : {{ (account ? account.mobile : '') }}</div>
              <div>{{ $t('address') }} :{{ (account ? account.address : '') }}</div>
            </div>
          </td>
        </tr>
        <tr class="table-header-print">
          <td align="center">
            #
          </td>
          <td align="center">
            {{ $t('product') }}/ {{ $t('service') }}
          </td>
          <td align="center">
            تعداد / وزن
          </td>
          <td align="center">
            {{ $t('fee') }}
          </td>
          <td align="center">
            {{ $t('discount') }}
          </td>
          <td align="center">
            {{ $t('sum') }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, i) in items"
          :key="i"
        >
          <td>{{ i + 1 }}</td>
          <td style="color: #000000">
            {{ (item.product ? item.product.name : '') }}
          </td>
          <td align="center">
            {{ item.count }}
          </td>
          <td align="center">
            {{ $numberFormat(item.fee) }}
          </td>
          <td align="center">
            <div>
              {{ (item.discount ? $numberFormat(item.discount) : '') }}
            </div>
            <div>
              {{ (item.discount ?'(' + item.discountPercent + '%)' : '') }}
            </div>
          </td>
          <td align="center">
            {{ $numberFormat((item.fee*item.count) - +item.discount + +item.tax) }}
          </td>
        </tr>
      </tbody>
      <tfoot v-show="status == 'print'">
        <tr>
          <td colspan="3">
            {{ $t('sum') }} {{ $t('discount') }}
          </td>
          <td
            colspan="3"
            align="center"
            style="font-weight: bold"
          >
            {{ $numberFormat(discount) }} {{ $store.state.currency.name }}
          </td>
        </tr>
        <tr>
          <td colspan="3">
            {{ $t('sum') }} {{ $t('tax') }}
          </td>
          <td
            colspan="3"
            align="center"
            style="font-weight: bold"
          >
            {{ $numberFormat(tax) }} {{ $store.state.currency.name }}
          </td>
        </tr>
        <tr>
          <td
            colspan="6"
            align="center"
            style="font-weight: bold;font-size: 12px"
          >
            {{ $t('payable') }} :  {{ $numberFormat(sum) }} {{ $store.state.currency.name }}
          </td>
        </tr>
        <tr v-if="content">
          <td colspan="6">
            {{ $t('content') }} : {{content}}
          </td>
        </tr>
      </tfoot>
    </table>
    <div
      v-if="$store.state.allConfig && status == 'print'"
      align="center"
      style="font-size: 11px;margin-top: 5px"
    >
      {{ $store.state.allConfig.address }} {{ ($store.state.allConfig.phone ? '-' + $store.state.allConfig.phone : '') }}
    </div>
<!--    <div-->
<!--      v-show="id"-->
<!--      style="margin-top: 15px"-->
<!--      align="center"-->
<!--    >-->
<!--      <img-->
<!--        width="80%"-->
<!--        class="barcode"-->
<!--        height="60px"-->
<!--        :jsbarcode-value="number"-->
<!--        jsbarcode-textmargin="0"-->
<!--        jsbarcode-fontoptions="bold"-->
<!--      >-->
<!--    </div>-->
    <div
      align="center"
      style="font-size: 8px"
    >
      abriron.com - راهکار های مالی ابرآیرون
    </div>
  </div>
</template>

<script>

  export default {
    name: 'IndexCategoryPrint',
    props: ['itemsProp', 'accountProp', 'dateProp', 'sumProp', 'totalDiscount', 'contentProp',
            'totalTax', 'idProp', 'numberProp', 'numberPrintProp', 'statusProp'],
    data () {
      return {
        date: null,
        time: null,
        account: null,
        items: null,
        content: null,
        sum: 0,
        tax: 0,
        discount: 0,
        id: 0,
        number: 0,
        numberPrint: 0,
        status: 'print',
      }
    },
    watch: {
      numberPrintProp (val) {
        this.numberPrint = val
      },
      contentProp (val) {
        this.content = val
      },
      dateProp (val) {
        this.date = val
      },
      itemsProp (val) {
        this.items = val
      },
      accountProp (val) {
        this.account = val
      },
      sumProp (val) {
        this.sum = val
      },
      totalDiscount (val) {
        this.discount = val
      },
      totalTax (val) {
        this.tax = val
      },
      statusProp (val) {
        this.status = val
      },
      idProp (val) {
        this.id = val
        // var app = this
        // setTimeout(function () {
        //   app.barcodeGenerate()
        // }, 10)
      },
      numberProp (val) {
        this.number = val
      },
    },
    mounted () {
      this.date = this.dateProp
      this.account = this.accountProp
      this.items = this.itemsProp
      this.sum = this.sumProp
      this.discount = this.totalDiscount
      this.tax = this.totalTax
      this.id = this.idProp
      this.number = this.numberProp
      this.numberPrint = this.numberPrintProp
      this.status = this.statusProp
      this.content = this.contentProp
      this.lockStatusItems = this.itemsProp
      // var barcode = document.createElement('script')
      // barcode.setAttribute('src', 'https://abr.abriron.com/js/JsBarcode.all.min.js')
      // document.head.appendChild(barcode)
      // var app = this
      // setTimeout(function () {
      //   app.barcodeGenerate()
      // }, 5000)
      var today = new Date()
      this.time = today.getHours() + ':' + today.getMinutes()
    },
    methods: {
      barcodeGenerate () {
        window.JsBarcode('.barcode').init()
      },
    },
  }
</script>

<style scoped>
  thead > tr > td{border: solid 1px #171717;padding: 5px;font-size: 10px}
  tbody > tr > td{border: solid 1px #171717;padding: 5px;font-size: 10px}
  tfoot > tr > td{border: solid 1px #171717;padding: 5px;font-size: 10px}
</style>
